import React, { useCallback } from "react";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import TablePagination from "@material-ui/core/TablePagination";
import { TablePaginationActionsProps } from "@material-ui/core/TablePagination/TablePaginationActions";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useStyles } from "./TableFooterPagination.styles";
import { tableStore } from "../../../mobx/stores/TableStore/TableStore";

interface TableFooterPaginationProps {
  colSpan: number;
}

export const TableFooterPagination = observer(({ colSpan }: TableFooterPaginationProps) => {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const { setTablePage, page } = tableStore;
  const history = useHistory();
  const { per_page } = page;

  return (
    <TableFooter>
      <TableRow>
        <TablePagination
          rowsPerPageOptions={[page.per_page]}
          page={page.current_page - 1}
          colSpan={colSpan}
          count={page.total}
          rowsPerPage={page.per_page}
          onChangePage={(_, page) => handleChangePage(page)}
          labelDisplayedRows={({ from, to, count }) => {
            if (page.to == null || page.from == null) return `0 - 0 из ${count}`;
            return `${from} - ${to} из ${count}`;
          }}
          ActionsComponent={TablePaginationActions}
        />
      </TableRow>
    </TableFooter>
  );

  function handleChangePage(page: number) {
    history.push({
      search: queryString.stringify({
        ...params,
        "page[size]": per_page,
        "page[number]": page,
      }),
    });
    setTablePage({ current_page: page, per_page });
  }
});

function TablePaginationActions(props: TablePaginationActionsProps) {
  const classes = useStyles();
  const { onChangePage, count, rowsPerPage, page } = props;

  const handleBackButtonClick = useCallback(
    (e) => {
      onChangePage(e, page);
    },
    [onChangePage, page]
  );
  const handleNextButtonClick = useCallback(
    (e) => {
      onChangePage(e, page + 2);
    },
    [onChangePage, page]
  );

  return (
    <div className={classes.root}>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
    </div>
  );
}
